import { render, staticRenderFns } from "./OrderEvaluateIndex.vue?vue&type=template&id=00cda7b7&scoped=true"
import script from "./OrderEvaluateIndex.vue?vue&type=script&lang=js"
export * from "./OrderEvaluateIndex.vue?vue&type=script&lang=js"
import style0 from "./OrderEvaluateIndex.vue?vue&type=style&index=0&id=00cda7b7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cda7b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00cda7b7')) {
      api.createRecord('00cda7b7', component.options)
    } else {
      api.reload('00cda7b7', component.options)
    }
    module.hot.accept("./OrderEvaluateIndex.vue?vue&type=template&id=00cda7b7&scoped=true", function () {
      api.rerender('00cda7b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/evaluate/OrderEvaluateIndex.vue"
export default component.exports